import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function PlayerFormDialog({
  open,
  onClose,
  onSubmit,
  initialData,
  loading,
  teams,
  defaultTeamId,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [name, setName] = useState("");
  const [jerseyNumber, setJerseyNumber] = useState("");
  const [teamId, setTeamId] = useState("");

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || "");
      setJerseyNumber(
        initialData.jersey_number
          ? String(initialData.jersey_number)
          : ""
      );
      setTeamId(
        initialData.team_id ? String(initialData.team_id) : ""
      );
    } else {
      setName("");
      setJerseyNumber("");
      setTeamId(defaultTeamId ? String(defaultTeamId) : "");
    }
  }, [initialData, open, defaultTeamId]);

  const handleSave = () => {
    onSubmit({
      name: name.trim(),
      jersey_number: jerseyNumber,
      team_id: teamId,
    });
  };

  const selectedTeamName =
    teams.find((team) => String(team.id) === teamId)?.name || "";

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: "18px",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          fontWeight: 700,
          fontSize: "1.05rem",
          mb: 3,
        }}
      >
        {initialData ? "Editar jugador" : "Nuevo jugador"}
      </DialogTitle>

      <DialogContent sx={{ pt: 2.2 }}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Nombre del jugador"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <TextField
            fullWidth
            label="Dorsal"
            type="number"
            value={jerseyNumber}
            onChange={(e) => setJerseyNumber(e.target.value)}
            inputProps={{ min: 0 }}
          />

          <TextField
            fullWidth
            label="Equipo"
            value={selectedTeamName}
            disabled
          />
        </Stack>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2.4,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleSave}
          variant="contained"
          disabled={
            loading ||
            !name.trim() ||
            !jerseyNumber ||
            !teamId
          }
        >
          {loading
            ? "Guardando..."
            : initialData
            ? "Actualizar"
            : "Crear"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}